import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule, UserService } from './core';
import { ToastrModule } from 'ngx-toastr';
import { SessionExpirationAlert } from 'session-expiration-alert';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MerchantAccountModule } from './merchant-account/merchant-account.module';
import { SpinnerModule } from '@uiowa/spinner';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas, faCreditCard, faBriefcase, faUserPlus, faCheckSquare, faSquare, faUserEdit, faUserMinus, faEdit, faPhone, faSave, faPaperPlane, faRedo, faDollarSign, faPercent, faTimes, faExclamation, faCaretDown, faToggleOff, faToggleOn, faTrash, faExpandAlt, faCompressAlt, faFile } from '@fortawesome/free-solid-svg-icons';
import { UniversityPersonModule, UniversityPersonService } from '@uiowa/university-person';
import { UniversityPersonSearchService } from './shared';

export function appUserServiceFactory(userService: UserService) {
  return () => userService.getUser();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    ToastrModule.forRoot(),
    SessionExpirationAlert.forRoot(),
    CoreModule,
    AppRoutingModule,
    MerchantAccountModule,
    SpinnerModule,
    UniversityPersonModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appUserServiceFactory,
      deps: [UserService],
      multi: true
      },
      {
          provide: UniversityPersonService,
          useFactory: (httpClient: HttpClient) => {
              return new UniversityPersonSearchService(httpClient);
          },
          deps: [HttpClient]
      }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas);
        library.addIcons(faCreditCard, faBriefcase, faUserPlus, faCheckSquare, faSquare, faUserEdit, faUserMinus, faEdit, faPhone, faSave, faPaperPlane, faRedo, faDollarSign, faPercent, faTimes, faExclamation, faCaretDown, faToggleOff, faToggleOn, faTrash, faExpandAlt, faCompressAlt, faFile);
    }
}
